import * as React from "react";
import { forwardRef } from "react";
const SvgBigArrowLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 10, viewBox: "0 0 13 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.00635 9.01172L2.00635 5.01372L6.00635 1.01172", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M2.00635 5.01172L12.0063 5.01172", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgBigArrowLeft);
export default ForwardRef;
